import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-put-store",
  "use": "icon-put-store-usage",
  "viewBox": "0 0 1177 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1177 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-put-store\"><defs><style type=\"text/css\"></style></defs><path d=\"M1023.93419 0H153.6L0.263239 296.775733 0 1024h1177.521028l-0.263239-730.488432-153.323599-293.511568zM358.426324 665.639486h153.547352V460.8h153.586838V665.639486h153.53419L589.221183 870.426324zM153.6 307.26581l102.4-204.786838h665.53419l102.386838 204.786838H153.6z\" p-id=\"5105\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol